import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Add as AddIcon, LocationOn as LocationOnIcon, } from "@mui/icons-material";
import { Avatar, Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { EmptyState } from "../common/EmptyState";
import { EntityListCard } from "../common/EntityListCard";
import { ManageButton } from "../utils/CardActions";
export const VenuesCard = ({ venues, canModify, title, manageUrl, emptyStateDescription = "Configure your team's home venues", linkable = true, }) => {
    return (_jsx(EntityListCard, { heading: title, count: venues.length, headerAction: canModify && _jsx(ManageButton, { to: manageUrl }), items: venues, renderRow: (venue, index, items) => {
            const content = (_jsxs(Box, { sx: {
                    p: 2.5,
                    display: "flex",
                    alignItems: "center",
                    ...(linkable && {
                        "&:hover": {
                            backgroundColor: "#f8f9ff",
                            transform: "translateX(2px)",
                        },
                    }),
                    transition: "all 0.2s ease",
                    borderBottom: index < items.length - 1
                        ? "1px solid rgba(0,0,0,0.08)"
                        : "none",
                }, children: [_jsx(Avatar, { sx: {
                            width: 40,
                            height: 40,
                            backgroundColor: "rgba(25, 118, 210, 0.1)",
                            color: "primary.main",
                        }, children: _jsx(LocationOnIcon, {}) }), _jsxs(Box, { sx: { ml: 2 }, children: [_jsx(Typography, { variant: "body1", sx: { fontWeight: 600, mb: 0.5 }, children: venue.name }), venue.formattedAddress && (_jsx(Typography, { variant: "caption", sx: {
                                    color: "text.secondary",
                                    display: "block",
                                }, children: venue.formattedAddress }))] })] }, linkable ? undefined : venue.id));
            return linkable ? (_jsx(Link, { to: `/venues/${venue.id}/`, style: { textDecoration: "none", color: "inherit" }, children: content }, venue.id)) : (content);
        }, emptyState: _jsx(EmptyState, { icon: _jsx(LocationOnIcon, {}), heading: "No home pitch yet", description: canModify ? emptyStateDescription : undefined, actionVariant: "icon", actionIcon: _jsx(AddIcon, {}), actionLabel: canModify ? "Add venue" : undefined, actionTo: canModify ? manageUrl : undefined }) }));
};
